import { useState } from "react";
import { BR, fmtN, mLabel, num, r2, sel, btnS } from "./BpKit";

export const dshort = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

const WeekCell = ({ r, w, locked, onWeek, booked }) => (
  <td className="text-right align-top">
    {locked ? <span className="num text-xs">{r.weeks?.[w.key] ? fmtN(r.weeks[w.key]) : "·"}</span> : (
      <input data-testid={`bp-weekly-cell-${r.key}-${w.key}`} type="number" min="0" step="any" inputMode="decimal" value={r.weeks?.[w.key] ?? ""}
        onChange={(e) => onWeek(r.key, w.key, e.target.value)}
        className="num w-[72px] h-8 px-1.5 text-right text-[13px] bg-white border border-slate-200 rounded-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary/30" />
    )}
    {r.account_id && <div className="num text-[10px] text-slate-500 mt-0.5" data-testid={`bp-weekly-booked-${r.key}-${w.key}`}>booked {fmtN(booked || 0)}</div>}
  </td>
);

export const WeeklyPo = ({ meta, rows, actual, locked, onWeek, onSplit }) => {
  const cur = meta.weeks.find((w) => w.key === meta.current_week);
  const [m, setM] = useState(cur && meta.fy === meta.current_fy ? cur.month : meta.months[0]);
  const weeks = meta.weeks.filter((w) => w.month === m);
  const tot = (f) => r2(rows.reduce((a, r) => a + f(r), 0));
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <select data-testid="bp-weekly-month-select" className={sel} value={m} onChange={(e) => setM(e.target.value)}>
          {meta.months.map((x) => <option key={x} value={x}>{mLabel(x)}</option>)}
        </select>
        {!locked && rows.length > 0 && <button type="button" className={btnS} data-testid="bp-weekly-split-button" onClick={() => onSplit(m, weeks)}>Split {mLabel(m)} plan across its weeks</button>}
      </div>
      {!rows.length ? <p className="text-sm text-slate-500" data-testid="bp-weekly-empty">Add accounts in the first tab, then plan their POs week by week here.</p> : (
        <div className="overflow-x-auto border border-slate-200 rounded-sm" data-testid="bp-weekly-grid">
          <table className="ax-table ax-freeze w-full">
            <thead>
              <tr>
                <th>Account</th><th className="text-right">{mLabel(m)} plan</th>
                {weeks.map((w) => <th key={w.key} className="text-right whitespace-nowrap">{w.key}<div className="text-[10px] font-normal normal-case text-slate-500">{dshort(w.start)} – {dshort(w.end)}</div></th>)}
                <th className="text-right">Weeks total</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const act = actual[`${r.account_id}:${r.branch}`] || {};
                const ws = r2(weeks.reduce((a, w) => a + num(r.weeks?.[w.key]), 0)), mp = num(r.months?.[m]);
                return (
                  <tr key={r.key} data-testid={`bp-weekly-row-${r.key}`}>
                    <td className="min-w-[190px]"><div className="text-[13px] font-medium">{r.account_name}</div><div className="text-[11px] text-slate-500">{BR[r.branch]}</div></td>
                    <td className="text-right num text-[13px]">{fmtN(mp)}</td>
                    {weeks.map((w) => <WeekCell key={w.key} r={r} w={w} locked={locked} onWeek={onWeek} booked={act[w.key]} />)}
                    <td className={`text-right num text-[13px] font-semibold ${mp && Math.abs(ws - mp) > 0.01 ? "text-amber-700" : ""}`} data-testid={`bp-weekly-total-${r.key}`}>{fmtN(ws)}</td>
                  </tr>
                );
              })}
              <tr className="bg-slate-100/80 font-semibold" data-testid="bp-weekly-sum-row">
                <td className="text-[13px]">All accounts</td>
                <td className="text-right num text-[13px]">{fmtN(tot((r) => num(r.months?.[m])))}</td>
                {weeks.map((w) => <td key={w.key} className="text-right num text-[13px]">{fmtN(tot((r) => num(r.weeks?.[w.key])))}</td>)}
                <td className="text-right num text-[13px]">{fmtN(tot((r) => weeks.reduce((a, w) => a + num(r.weeks?.[w.key]), 0)))}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <p className="text-xs text-slate-500">BP weeks run Saturday to Friday, like the BP sheet. An amber total doesn't match the month's plan. "Booked" counts POs dated in that week.</p>
    </div>
  );
};
